exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".full[data-v-53798374]{width:100%;height:100%}", ""]);
